import { useForm } from 'react-final-form';
import colors from 'constants/colors';
import { HeaderContent } from './headerContent';

export const Header = () => {
  const form = useForm();
  const headerBgColor = form.getFieldState('header_bg_color')?.value || colors.oathBlue;

  return (
    <>
      {form.getState().values?.previewVideo ? (
        <>
          <video
            id="previewVideo"
            className="previewVideo"
            src={form.getState().values?.previewVideo}
            playsInline
            autoPlay
            loop
            muted
          />
          <div className="header-preview-texts-container-absolute">
            <HeaderContent />
          </div>
        </>
      ) : (
        <div
          className="header-preview-container"
          style={{
            backgroundColor: headerBgColor,
          }}
        >
          <div className="header-preview-texts-container">
            {form.getState().values?.previewLogo && (
              <img id="previewLogo" className="preview" src={form.getState().values?.previewLogo} />
            )}
            <HeaderContent />
          </div>
        </div>
      )}
    </>
  );
};
